import type { FaireProductEntity } from "../../entity_types/product";

export const p_gd72vfu7ny: FaireProductEntity = {
  token: "p_gd72vfu7ny",
  type: "product",
  name: "Dried Flowers - Field Bouquet - Pink",
  brandToken: "b_4qm8pqu56k",
  brandName: "Wildflowers by Floriette",
  imageUrl:
    "https://cdn.faire.com/fastly/bdeba3454c32c0956f037c8a275567fd4a28c8c67a9b89688a6e68c083ebffb6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aa58861a3025bdc0af8626987bd0145413bec97400ba40a614e203b204ae9ca9.jpeg",
    "https://cdn.faire.com/fastly/6602c9f5ad45935b0ea961e66703f31dd5f14d16e55d8b92b4f026a0f9c77963.jpeg",
    "https://cdn.faire.com/fastly/74e538157065c03cc4880d16d52fbcee1af9b357a2eb37960422856388c014a0.jpeg",
    "https://cdn.faire.com/fastly/80286ff9433570c5932d01ebd495a939b088f135c8b77aa0611f979e3f254d70.jpeg",
  ],
  priceDollars: 15,
  description:
    "Introducing our exquisite Dried Flowers Field Bouquet Pink. Enrich your space with the beauty of dried flowers, carefully handcrafted and sustainably grown for a touch of eco-conscious elegance. Each piece is thoughtfully curated with love, resulting in a stunning composition that captures the essence of natural beauty. These charming bouquets are also available in Small, Medium and Large. \n\nPlease note that dried flowers are natural and seasonal products, which may lead to variations in flower types and colors compared to the photo. Embrace the surprises that come with these ever-changing botanical wonders and add a touch of enchantment to any environment.\n\nSmall: 35 cm\nMedium: 50 cm\nLarge: 60 cm\n",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:44.485Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
